import {createTheme} from "@mui/material";

export const rtlTheme = createTheme({
    direction: 'rtl',
    palette: {
        mode: 'dark',
        primary: {
            main: '#00A1E1', // This sets the primary color to white
        },
        background: {
            default: '#05101D',
            // default:/* '#080808',
            // paper: */'#080808',
            paper: '#05101D',
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    // Define CSS variables
                    '--sidebar-surface-primary': '#171717',
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: "#A5A5A5"
                }
            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: 'var(--sidebar-surface-primary)'
                }
            }
        },
        MuiToolbar: {
            styleOverrides: {
                regular: {  // This targets the default style
                    minHeight: 90,  // Default height
                    '@media (min-width:0px)': {
                        minHeight: 60,  // Height for extra-small screens
                    },
                    '@media (min-width:600px)': {
                        minHeight: 60,  // Height for small screens
                    },
                    '@media (min-width:900px)': {
                        minHeight: 60,  // Height for medium screens
                    },
                    '@media (min-width:1200px)': {
                        minHeight: 90,  // Height for large screens
                    },
                    '@media (min-width:1536px)': {
                        minHeight: 90,  // Height for extra-large screens
                    },
                }
            }
        },

        MuiTypography: {
            styleOverrides: {
                root: {
                    color: 'inherit', // Makes Typography components inherit color from parent
                }
            }
        }
    },
    shape: {
        borderRadius: 13
    },
    typography: {
        fontFamily: [
            'Urbanist',
            'Varela Round',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Arial',
            'sans-serif'
        ].join(','),
        h5: {
            color: '#000',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '150%',
        },
    }
});

export const ltrTheme = createTheme({
    direction: 'ltr',
    palette: {
        mode: 'dark',
        primary: {
            main: '#00A1E1', // This sets the primary color to white
        },
        background: {
            default: '#05101D',
            // default:/* '#080808',
            // paper: */'#080808',
            paper: '#05101D',
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none', // Overrides uppercase text transformation
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    // Define CSS variables
                    '--sidebar-surface-primary': '#171717',
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: "#A5A5A5"
                }
            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: 'var(--sidebar-surface-primary)'
                }
            }
        },
        MuiToolbar: {
            styleOverrides: {
                regular: {  // This targets the default style
                    minHeight: 90,  // Default height
                    '@media (min-width:0px)': {
                        minHeight: 60,  // Height for extra-small screens
                    },
                    '@media (min-width:600px)': {
                        minHeight: 60,  // Height for small screens
                    },
                    '@media (min-width:900px)': {
                        minHeight: 60,  // Height for medium screens
                    },
                    '@media (min-width:1200px)': {
                        minHeight: 90,  // Height for large screens
                    },
                    '@media (min-width:1536px)': {
                        minHeight: 90,  // Height for extra-large screens
                    },
                }
            }
        },

        MuiTypography: {
            styleOverrides: {
                root: {
                    color: 'inherit', // Makes Typography components inherit color from parent
                }
            }
        }
    },
    shape: {
        borderRadius: 13
    },
    typography: {
        fontFamily: [
            'Urbanist',
            'Varela Round',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Arial',
            'sans-serif'
        ].join(','),
        h5: {
            color: '#000',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '150%',
        },
    }
});